<template>
	<div id="pg6" >
		<section class="match">
			<img v-responsive.xl.lg src="@/assets/landing/capacitador/match/HOME2 1680x1050.jpg"
				 class="section_img">
			<img v-responsive.md src="@/assets/landing/capacitador/match/HOME2 1024x768.jpg"
				 class="section_img">
			<img v-responsive.xs.sm src="@/assets/landing/capacitador/match/HOME2 768x1024.jpg"
				 class="section_img">
			<div class="hyper-link">
				<div :class="isMobile ? 'row justify-content-center' : ''" >
					<a href="/perfil/cursos"  :class="isMobile ? 'btn b-orange w-70 float-left' :  'btn b-orange w-50 float-right'" v-if="isLogin">
						¡Comienza Ahora!
					</a>
					<a href="/registrar/capacitador"  :class="isMobile ? 'btn b-orange w-70 float-left' :  'btn b-orange w-50 float-right'" v-else>
						¡Comienza Ahora!
					</a>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "publicar-cursos-uno",
	props: ['isLogin'],
	data() {
		return {
			isMobile: this.$mobile(),
		}
	}
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.match{
	position:relative;
}
.match .hyper-link a{
	font-size: large;
}
.match .hyper-link{
	position: absolute;
	bottom: 15%;
	right: 21%;
	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top: 79%;
		left: 5%;
		width: 90%; 
	}
	@media only screen and (min-width: 768px) {
		bottom: 25%;
		right: 18%;
		width: 45%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 25%;
		right: 15%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 33%;
		right: 14%;
		width: 25%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 15%;
		right: 21%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 4%;
		right: 3%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		right: 21%;
	}
	/* different techniques for iPad screening */
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
		bottom: 8%;
		right: 11%;
	}

	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
		/* For landscape layouts only */
		bottom: 15%;
		right: 21%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/landing/capacitador/publicar-cursos-uno.vue